var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.601,
    height: 46.741,
    viewBox: "0 0 211.601 46.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.556,
    cy: 0.5,
    r: 0.649,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c800f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#c301f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#b605ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a10ddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8317c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#5c24ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#2e348f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d358f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.461,
    cy: 0.44,
    r: 0.593,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111618",
    "data-name": "Group 111618",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(10.575 21.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M371.752,286.969H347V271h24.752Zm-21.558-3.194h18.364v-9.581H350.194Z",
    transform: "translate(-347 -271)",
    fill: "#00b4e9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M320.512,217v46.454H365.09v-5.06H325.572V222.059h59.792V241.3h5.059V217Z",
    transform: "translate(-320.512 -217)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(38.198 17.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M447.88,267.9q-.011-1.3-.011-2.6c0-.086.016-.782.031-1.545,0-.616,0-1.276.012-1.707l-31.719,28.435h7.579l24.118-21.622C447.874,268.566,447.879,267.84,447.88,267.9Z",
    transform: "translate(-416.193 -262.043)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 5.059,
    height: 31.105,
    transform: "matrix(0.745, -0.668, 0.668, 0.745, 6.756, 5.598)",
    fill: "url(#radial-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(80.25 14.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M288.885,348.153l-6.975,8.828,6.975,8.828h-4.977l-5.534-7-5.534,7h-4.977l6.975-8.828-6.975-8.828h4.977l5.534,7,5.534-7Z",
    transform: "translate(-267.864 -348.153)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M336.4,348.153v4.032H329.09v13.624h-4.033V352.185H317.49v-4.032Z",
    transform: "translate(-292.808 -348.153)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M377.665,361.329H366.913v4.48h-4.032V353.4a5,5,0,0,1,1.49-3.68,4.942,4.942,0,0,1,3.62-1.562H381.7v17.656h-4.032Zm0-4.034v-5.122h-9.674a1.053,1.053,0,0,0-.762.267.955.955,0,0,0-.315.689v4.165Z",
    transform: "translate(-315.624 -348.153)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M408.075,365.809V348.153h18.234V353a5.469,5.469,0,0,1-1.2,3.838,4.1,4.1,0,0,1,1.441,3.548v1.551a3.784,3.784,0,0,1-1.042,2.761,3.663,3.663,0,0,1-2.688,1.115Zm4.031-10.85h8.136q1.744,0,1.744-1.622v-1.151h-9.88Zm0,6.818h8.27q1.609,0,1.61-1.394t-1.61-1.38h-8.27Z",
    transform: "translate(-338.34 -348.153)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M456.616,360.832a.961.961,0,0,0,.314.69,1.033,1.033,0,0,0,.763.266h12.8v4.021h-12.8a5.211,5.211,0,0,1-5.109-5.244V348.153h4.032Z",
    transform: "translate(-360.712 -348.153)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M513.863,352.185H499.985v2.773h13.878V359H499.985v1.829a.96.96,0,0,0,.315.69,1.03,1.03,0,0,0,.762.266h12.8v4.021h-12.8a5.212,5.212,0,0,1-5.11-5.244V348.153h17.91Z",
    transform: "translate(-382.511 -348.153)",
    fill: "#0071bc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb06f119917cce282fb12b8b62600b9c.svg";
export { ForwardRef as ReactComponent };